<template>
    <div class="main-content no-padding noscroll">
        <Loading v-show="loading"/>

        <div class="funnel_apps noscroll layout-column">
            <div class="funnel_apps_header">
                <h3>Funnel apps <span class="panel_head_amount">({{apps.length}})</span></h3>
            </div>
            <div class="scroll" :class="{toggling}">
	            <div class="funnel_apps_list" :class="{toggling}">
		            <app-entry v-for="(item, index) in apps" :app="item" :is-plus="true"
		                       :url="{path: `/wfunnel/${$route.params.id}/apps/${item.id}`}" :key="item.id" />
	            </div>
            </div>
        </div>

        <!-- APP DETAILS -->
        <router-view @update="updated($event)" :funnel="funnel"/>
    </div>
</template>

<script>
import API from "@/api"
import Loading from "@/components/Loading.vue"
import AppEntry from "@/components/app-entry";

export default {
    name: "FunnelApps",
    components: {
	    AppEntry,
        Loading
    },
    mixins: [API],
    props: ['funnel'],
    data() {
        return {
            toggling: false,
            loading: true,
            notifShow: true,
            apps: [],
            currentApp: {},
        }
    },
    computed: {
    },
    methods: {
      updated(funnelApp) {
        this.apps.forEach(app => {
            if (app.id == funnelApp.app_id) {
	            app.funnel_app.active = funnelApp.active;
	            app.funnel_app.config = funnelApp.config; // must also update config, as it's used in PATCH
            }
        });
      },
      async init(id) {
        try {
	        this.loading = true;
	        this.apps = [];

	        this.apps = await this.api.apps.getFunnelPlusApps(id);

        } catch (e) {
	        this.$notify({
		        group: 'main',
		        title: "Something went wrong! try again later, or contact chat support.",
		        type: 'error',
	        });
	        console.error("error:", e);
        } finally {
	        this.loading = false;
        }
      }
    },
    created() {
      let {id} = this.$route.params;
      this.init(id);
    },
}
</script>

<style scoped>
.loading {
    height: calc(100vh - 71px);
}
</style>
